<template id="youtube-player">
    <div class="video-container bg-white">
        <h2 class="title-text">Why you should join Project Athena...</h2>
        <youtube :video-id="videoId"></youtube>
    </div>
</template>

<script>
export default {
    name: 'HomeYoutube',
    data() {
        return {
            videoId: 'kGoyK4wZYas'
        };
    }
};
</script>

<style scoped>
@import '../assets/styles/main.css';
</style>
